import classNames from 'classnames';
import useWorldTheme from 'hooks/shared/useWorldTheme';
import { forwardRef } from 'react';
import type { VariantButtonProps } from './VariantButton.types';

const colorBasedClasses: Record<string, string> = {
  expenses:
    'border-expenses text-expenses focus:ring-2 focus:ring-expenses-100',
  revenues:
    'border-revenues text-revenues focus:ring-2 focus:ring-revenues-100',
  taxes: 'border-taxes text-taxes focus:ring-2 focus:ring-taxes-100',
  bank: 'border-bank text-bank focus:ring-2 focus:ring-bank-100',
  primary: 'border-primary text-primary focus:ring-2 focus:ring-primary-100',
};

const VariantButton = forwardRef<HTMLButtonElement, VariantButtonProps>(
  (
    {
      selected = false,
      children,
      iconSrc,
      buttonClassName,
      iconClassName,
      color,
      useAIColorScheme,
      ...props
    },
    ref,
  ) => {
    const worldColor = useWorldTheme();
    const buttonColor = color || worldColor;
    return (
      <button
        type="button"
        ref={ref}
        className={classNames(
          buttonClassName,
          'text-sm text-center flex-1 rounded-[0.625rem] py-2 px-1.5 cursor-pointer font-assistant font-semibold border',
          'transition-colors transition-shadow',
          {
            'text-primary-700 border-primary-100 hover:bg-primary-50 focus:bg-primary-50':
              !selected,
            [colorBasedClasses[buttonColor] || colorBasedClasses.primary]:
              selected,
            'ai-button-bg-border':
              useAIColorScheme && selected && !props.disabled,
            'cursor-not-allowed bg-primary-50': props.disabled,
            'shadow-[0px_1px_2px_0px_rgba(53,26,77,0.03)] bg-white':
              !props.disabled,
          },
        )}
        {...props}
      >
        {iconSrc ? (
          <img
            className={classNames('mx-auto mb-1', iconClassName)}
            src={iconSrc}
          />
        ) : null}
        {children}
      </button>
    );
  },
);

VariantButton.displayName = 'VariantButton';

export default VariantButton;
